// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getBrandingV2RequestToJson, getBrandingV2ResponseFromJson, getMultiBrandingV2RequestToJson, getMultiBrandingV2ResponseFromJson, listBrandingV2RequestToJson, listBrandingV2ResponseFromJson, upsertBrandingV2RequestToJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getBranding(request) {
    const raw = await fetchRpc('partner.v1.BrandingV2Service/GetBranding', getBrandingV2RequestToJson(request));
    return getBrandingV2ResponseFromJson(raw);
}
export function getBranding$(request, options) {
    return defer(() => getBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function getBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.BrandingV2Service/GetBranding', getBrandingV2RequestToJson(request), options)
        .pipe(map(resp => getBrandingV2ResponseFromJson(resp)));
}
export async function getMultiBranding(request) {
    const raw = await fetchRpc('partner.v1.BrandingV2Service/GetMultiBranding', getMultiBrandingV2RequestToJson(request));
    return getMultiBrandingV2ResponseFromJson(raw);
}
export function getMultiBranding$(request, options) {
    return defer(() => getMultiBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function getMultiBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.BrandingV2Service/GetMultiBranding', getMultiBrandingV2RequestToJson(request), options)
        .pipe(map(resp => getMultiBrandingV2ResponseFromJson(resp)));
}
export async function listBranding(request) {
    const raw = await fetchRpc('partner.v1.BrandingV2Service/ListBranding', listBrandingV2RequestToJson(request));
    return listBrandingV2ResponseFromJson(raw);
}
export function listBranding$(request, options) {
    return defer(() => listBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function listBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.BrandingV2Service/ListBranding', listBrandingV2RequestToJson(request), options)
        .pipe(map(resp => listBrandingV2ResponseFromJson(resp)));
}
export async function upsertBranding(request) {
    await fetchRpc('partner.v1.BrandingV2Service/UpsertBranding', upsertBrandingV2RequestToJson(request));
}
export function upsertBranding$(request, options) {
    return defer(() => upsertBrandingWithTransport$(getGlobalTransport(), request, options));
}
export function upsertBrandingWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.BrandingV2Service/UpsertBranding', upsertBrandingV2RequestToJson(request), options)
        .pipe(map(() => undefined));
}
